import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";

function FormButton(props) {
  const { button, buttonText, handleClickOpen, add } = props;
  return (
    <>
      {button ? (
        <Button
          onClick={handleClickOpen}
          color="secondary"
          component="span"
          size="small"
        >
          {buttonText}
        </Button>
      ) : (
        <IconButton onClick={handleClickOpen} title={buttonText}>
          <SvgIcon>
            {add ? (
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
            ) : (
              <path d="M 18.414062 2 C 18.158188 2 17.902031 2.0974687 17.707031 2.2929688 L 16 4 L 20 8 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.925594 2.0974687 18.669937 2 18.414062 2 z M 14.5 5.5 L 3 17 L 3 21 L 7 21 L 18.5 9.5 L 14.5 5.5 z" />
            )}
          </SvgIcon>
        </IconButton>
      )}
    </>
  );
}

export default FormButton;
